var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticStyle:{"width":"100%"},style:({ height: _vm.height + 'px' }),attrs:{"id":"type"}})}
var staticRenderFns = []

export { render, staticRenderFns }